import axios from 'axios'

export default function (context) {
    let formData = context.getters['form/data'];
    let data = '';
    for (let k in formData) {
        data += k + '=' + formData[k] + '&';
    }
    data += 'Columns=3&Columns=4&Columns=5&Columns=6&Columns=7&Columns=8&Columns=9&Columns=10&Columns=14&Columns=12&Columns=13&Columns=15&Columns=16';
    axios({
        method: 'post',
        url: '/tourclient/balanceSheet/create',
        data,
        requestId: 'tourclient/balanceSheet/create'
    }).then(({data}) => {
        context.commit('set', data.Rows);
    }).catch(e => {
        context.state.loading = false;
        context.dispatch('error', e, {root: true});
    })
}